export const environment = {
  production: true,
  baseURL: './../server',
  graphqlURL: './../server',
  accessTokenKey: 'ProdSbsChaserAccessToken',
  refreshTokenKey: 'ProdbsChaserRefreshToken',
  profileKey: 'ProdSbsChaserProfileKey',
  vapidPublicKey: 'replaced-by-build-script',
}
